export const VERSION = '__VERSION__';
export const BUILD_DATE = '__BUILD_DATE__';